import React from "react";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

const KMKDateRangePicker = (props) => {
  return <RangePicker {...props} />;
};

export default KMKDateRangePicker;
